import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';

import Layout from './components/Layout/Layout';
import MainPage from './components/MainPage/MainPage';
import RegistrationMembersOnly from './components/Registration/RegistrationMembersOnly';
import { DocumentModalProvider, useDocumentModal } from './components/DocumentModalContext/DocumentModalContext';

import './App.css';

function CookieBanner() {
  const { openModal } = useDocumentModal();

  return (
    <CookieConsent
      location="bottom"
      buttonText="Akceptuj"
      cookieName="konferencjaConsent"
      style={{ background: "#2B373B", justifyContent: "center" }}
      buttonStyle={{ color: "#fff", fontSize: "16px", borderRadius: "4px", background: "#4e73df" }}
      expires={365}
      overlay={true}
    >
      Ta strona używa plików cookies.{' '}
      <a href="#" onClick={(e) => { e.preventDefault(); openModal('privacy'); }}>
        Polityka Prywatności
      </a>
    </CookieConsent>
  );
}

function App() {
  return (
    <DocumentModalProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<MainPage />} />
            {/* <Route path="/czlonkowie-rejestracja" element={<RegistrationMembersOnly />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <CookieBanner />
    </DocumentModalProvider>
  );
}

export default App;
